import React, { Component } from "react";
import { message } from "antd";
import { Navigate } from "react-router-dom";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import actions from "../../redux/action";
import LoginRender from "./children/LoginRender";
import ForgotAndResetPasswordModal from "../forgotPasswordModal/ForgotAndResetPasswordModal";
import { requestLogin, requsetGetProfile, requsetGetSubscription } from "../../api/apis";
import { GALoginPageDisplay, GALoginFromError } from "../../ga/login";
import Cookies from "js-cookie";
import api_domain_config from "../../constants/common";
import "../../assets/login.scss";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      forgotPasswordModalVisible: false, //忘记密码弹窗控制显示变量
      loginLoading: false, //正在登陆状态
      linkToPersonalCenter: false, //是否跳转到个人中心
      linkToPurchase: false, //是否跳转到购买链接
    };
  }

  componentDidMount() {
    GALoginPageDisplay();
  }

  /**
   * 跳转到当前个人中心
   */
  handleNavigationToPersonalCenter = () => {
    this.setState(
      {
        linkToPersonalCenter: true,
      },
      () =>
        this.setState({
          linkToPersonalCenter: false,
        })
    );
  };

  /**
   * 跳转到购买页面
   */
  handleNavigationToPurchase = () => {
    this.setState(
      {
        linkToPurchase: true,
      },
      () =>
        this.setState({
          linkToPurchase: false,
        })
    );
  };

  /**
   *控制忘记密码弹窗的出现和隐藏
   * @param {*Boolean} forgotPasswordModalVisible false即隐藏，true即显示
   */
  handleForgotPasswordModalVisible = forgotPasswordModalVisible => {
    this.setState({
      forgotPasswordModalVisible,
    });
  };

  /**
   *登录请求
   */
  handleRequestLogin = value => {
    const urlParams = new URLSearchParams(this.props.urlSearch);
    this.setState({
      loginLoading: true,
    });
    let formData = new FormData();
    formData.append("email", value.email.replace(/(^\s*)|(\s*$)/g, ""));
    formData.append("password", value.password);
    if (urlParams.has("auth")) {
      formData.append("previous_authorization", urlParams.get("auth"));
    }
    requestLogin({
      body: formData,
    })
      .then(res => {
        if (res.code === 200) {
          message.success(this.props.t("loginSuccessTips"));
          // localStorage.setItem("authorization", res.data.authorization);
          localStorage.setItem("isSignin", "yes");
          //将当前auth存在顶级域名cookies底下
          Cookies.set("authorization", res.data.authorization, { expires: 30, domain: api_domain_config.DOMAIN });
          this.props.onAuthorizationChange(res.data.authorization);
          const redirect = urlParams.get("redirect");
          const to = urlParams.get("to");
          //如果需要有购买信息的话，请求订阅接口看看是否是vip
          this.handleGetSubscription(redirect && to === "purchase" ? true : false);
          this.handleRequsetGetProfile(res.data.authorization);
          if (value.remember) {
            console.log("用户记住密码");
            Cookies.set("_u_info", JSON.stringify({ e: value.email.replace(/(^\s*)|(\s*$)/g, ""), p: value.password }), {
              domain: api_domain_config.DOMAIN,
            });
          } else {
            console.log("用户不记住");
            if (Cookies.get("_u_info")) {
              Cookies.remove("_u_info", { domain: api_domain_config.DOMAIN });
            }
          }
        } else {
          GALoginFromError(res.message);
        }
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        this.setState({
          loginLoading: false,
        });
      });
  };

  /**
   *请求获取用户信息
   */
  handleRequsetGetProfile = authorization => {
    requsetGetProfile({ headers: { authorization } })
      .then(res => {
        if (res.code === 200) {
          this.props.onProfileObjChange(res.data);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };
  /**
   * 获取用户订阅信息
   * @param {Boolean} isRedirect 是否有需要订阅信息执行重定向
   */
  handleGetSubscription = isRedirect => {
    if (!isRedirect) {
      this.handleLoginRedirect();
    }
    requsetGetSubscription()
      .then(res => {
        console.log(res);
        if (res.code === 200) {
          this.props.onSubscriptionChange(res.data.subscription);
          this.handleLoginRedirect(res.data.subscription && res.data.subscription.status === "Active" ? true : false);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  /**
   *控制用户登录完毕登录后的跳转链接
   * @param {Boolean} isVIP 当前用户是不是VIP（非必填）
   */
  handleLoginRedirect = isVIP => {
    console.log(isVIP);
    const urlParams = new URLSearchParams(this.props.urlSearch);
    const redirect = urlParams.get("redirect");
    const to = urlParams.get("to");
    if (urlParams.has("redirect")) {
      console.log("sssssssssssdfasfasfasf", urlParams);
      if (redirect && to === "purchase" && !isVIP) {
        console.log("购买链接");
        this.handleNavigationToPurchase();
      } else if ((redirect && !to) || (redirect && to === "purchase" && isVIP)) {
        console.log("直接重定向到上一个链接");
        window.location.replace(redirect);
      }
    } else {
      console.log("跳转到某个链接");
      this.handleNavigationToPersonalCenter();
    }
  };

  render() {
    return (
      <div className="login-page overflow-hidden">
        {this.state.linkToPersonalCenter && <Navigate to="/personal-center/profile" replace="true" />}
        {this.state.linkToPurchase && <Navigate to={`/purchase${this.props.urlSearch}`} replace={true} />}

        <LoginRender
          handleForgotPasswordModalVisible={this.handleForgotPasswordModalVisible}
          loginLoading={this.state.loginLoading}
          handleRequestLogin={this.handleRequestLogin}
          urlSearch={this.props.urlSearch}
        />
        {this.state.forgotPasswordModalVisible && (
          <ForgotAndResetPasswordModal visible={this.state.forgotPasswordModalVisible} handleVisible={this.handleForgotPasswordModalVisible} />
        )}
      </div>
    );
  }
}

const mapStateToPropos = state => ({
  profileObj: state.account.profileObj,
  authorization: state.account.authorization,
});
const mapDispatchToProps = dispatch => ({
  onProfileObjChange: profileObj => dispatch(actions.onProfileObjChange(profileObj)),
  onAuthorizationChange: authorization => dispatch(actions.onAuthorizationChange(authorization)),
  onSubscriptionChange: subscription => dispatch(actions.onSubscriptionChange(subscription)),
});

export default connect(mapStateToPropos, mapDispatchToProps)(withTranslation(["loginAndSignUp"])(Login));
